import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { IHomework, THomeworkFile } from '.';

type TGetHomeworkSubmissions = {
  student: string;
  section: string;
};

type TGetHomeworkSubmissionsByCourse = {
  course: string;
  section?: string;
};

export type TCreateHomeworkSubmission = {
  section: string;
  student: string;
  description: string;
  link?: string;
  files?: Array<THomeworkFile>;
};

export type TUpdateHomeworkSubmission = {
  _id: string;
  description: string;
  link?: string;
  files?: Array<THomeworkFile>;
};

const apiDataProvider = new APIDataProvider();

export const getHomeworkSubmissions = createAsyncThunk(
  '/homeworks/get',
  async ({ section, student }: TGetHomeworkSubmissions) => {
    const path = `${ApiPaths.homeworks}?section=${section}&student=${student}`;
    const response = await apiDataProvider.get<TApiResponse<Array<IHomework>>>(
      path
    );

    return response.data;
  }
);

export const getHomeworkSubmissionsByCourse = createAsyncThunk(
  '/homeworks/get-by-course',
  async ({ course, section }: TGetHomeworkSubmissionsByCourse) => {
    let path = `${ApiPaths.homeworks}/by-course?course=${course}`;

    if (section) {
      path += `&section=${section}`;
    }

    const response = await apiDataProvider.get<TApiResponse<Array<IHomework>>>(
      path
    );

    return response.data;
  }
);

export const createHomeworkSubmission = createAsyncThunk(
  '/homeworks/create',
  async (data: TCreateHomeworkSubmission) => {
    const path = `${ApiPaths.homeworks}/submissions`;
    const response = await apiDataProvider.post<TApiResponse<IHomework>>(
      path,
      data
    );

    return response.data;
  }
);

export const updateHomeworkSubmission = createAsyncThunk(
  '/homeworks/update',
  async ({ _id, ...data }: TUpdateHomeworkSubmission) => {
    const path = `${ApiPaths.homeworks}/submissions/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<IHomework>>(
      path,
      data
    );

    return response.data;
  }
);

export const deleteHomeworkSubmission = createAsyncThunk(
  '/homeworks/delete',
  async (id: string) => {
    const path = `${ApiPaths.homeworks}/submissions/${id}`;
    const response = await apiDataProvider.delete<TApiResponse<IHomework>>(
      path
    );

    return response.data;
  }
);
